module.exports = __webpack_public_path__ + "static/media/image-7.b9b7e4ff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Blog/SEOin2020/image-7.jpg
// module id = 487
// module chunks = 0